import { ChapterType, TextBlock } from "graphql/types"
import { useStoreState } from "./storeHooks"

export const useGetTextBlocksForReport = (
  chapter: ChapterType,
  examinationIds: string[],
  normIds: string[]
): TextBlock[] => {
  const textBlocks: TextBlock[] = useStoreState((state) => state.textBlocks)

  return textBlocks.filter((block) => {
    // Prüfe, ob der ChapterType übereinstimmt
    const chapterMatches = block.chapter === chapter

    // Prüfe, ob mindestens eine examinationId übereinstimmt ODER examinations leer ist
    const hasMatchingExamination =
      block.examinations.length === 0 ||
      examinationIds.some((id) => block.examinations.includes(id))

    // Prüfe, ob mindestens eine normId übereinstimmt ODER norms leer ist
    const hasMatchingNorm =
      block.norms.length === 0 || normIds.some((id) => block.norms.some((norm) => norm === id))

    return chapterMatches && hasMatchingExamination && hasMatchingNorm
  })
}
